import React from 'react';
import PropTypes from 'prop-types';
import { BackIcon, CloseBigIcon } from './icons';
import ModalButton from './ModalButton';
import styles from './ModalBackground.module.css';
function ModalBackground(_a) {
    var back = _a.back, children = _a.children, close = _a.close;
    return (React.createElement("div", { className: styles.modalBackground },
        children,
        back && (React.createElement(ModalButton, { onClick: back, position: "left" },
            React.createElement(BackIcon, { display: "block" }))),
        close && (React.createElement(ModalButton, { onClick: close, position: "right" },
            React.createElement(CloseBigIcon, { display: "block" })))));
}
ModalBackground.propTypes = {
    back: PropTypes.func,
    children: PropTypes.node.isRequired,
    close: PropTypes.func,
};
export default ModalBackground;
